module.exports = __webpack_public_path__ + "media/promo/advent/images/treem-top-df9a01f04762f9ab1e34da67e7a12e33.png";